"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerReviewService = void 0;
var CustomerReviewService = /** @class */ (function () {
    function CustomerReviewService(reviewClient, embedClient) {
        this.reviewClient = reviewClient;
        this.embedClient = embedClient;
        this.franchisePromises = new Map();
        this.ratingPromises = new Map();
    }
    CustomerReviewService.prototype.loadFranchise = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var key, promise;
            return __generator(this, function (_a) {
                key = JSON.stringify(params);
                promise = this.franchisePromises.get(key);
                if (!promise) {
                    promise = (this.reviewClient.getBroadlyFranchise(params)).then(function (response) { return response.data[0]; });
                    this.franchisePromises.set(key, promise);
                }
                return [2 /*return*/, promise];
            });
        });
    };
    CustomerReviewService.prototype.loadRating = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var key, promise;
            return __generator(this, function (_a) {
                key = JSON.stringify(params);
                promise = this.ratingPromises.get(key);
                if (!promise) {
                    promise = (this.reviewClient.getBroadlyRating(params)).then(function (response) { return response.data; });
                    this.ratingPromises.set(key, promise);
                }
                return [2 /*return*/, promise];
            });
        });
    };
    CustomerReviewService.prototype.loadPageCount = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var result, franchiseLocation, counts, reviewCountResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        result = {
                            pageCount: 0,
                            reviewCount: 0,
                            displayCount: 0
                        };
                        if (!(params.dataSource == "embed" && (params.franchiseWebLocationId || params.franchiseWebLocationMarketingId))) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.loadFranchise({
                                franchiseWebLocationId: params.franchiseWebLocationId,
                                franchiseWebLocationMarketingId: params.franchiseWebLocationMarketingId
                            })];
                    case 1:
                        franchiseLocation = _a.sent();
                        if (!franchiseLocation) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.embedClient.getBroadlyEmbedReviewCount(franchiseLocation.externalFranchiseReference)];
                    case 2:
                        counts = _a.sent();
                        result.reviewCount = counts.real;
                        result.displayCount = counts.display;
                        _a.label = 3;
                    case 3: return [3 /*break*/, 6];
                    case 4: return [4 /*yield*/, this.reviewClient.getBroadlyReviewCount({
                            conceptId: params.conceptId,
                            franchiseId: params.franchiseId,
                            franchiseWebLocationId: params.franchiseWebLocationId,
                            franchiseWebLocationMarketingId: params.franchiseWebLocationMarketingId
                        })];
                    case 5:
                        reviewCountResponse = _a.sent();
                        result.reviewCount = reviewCountResponse.data;
                        result.displayCount = result.reviewCount;
                        _a.label = 6;
                    case 6:
                        result.pageCount = Math.ceil(result.reviewCount / params.pageSize);
                        return [2 /*return*/, result];
                }
            });
        });
    };
    CustomerReviewService.prototype.loadReviews = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var result, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        result = {
                            reviews: []
                        };
                        // if (params.dataSource == "embed" && (params.franchiseWebLocationId || params.franchiseWebLocationMarketingId))
                        // {
                        //     let franchiseLocation = await this.loadFranchise({
                        //         franchiseWebLocationId: params.franchiseWebLocationId,
                        //         franchiseWebLocationMarketingId: params.franchiseWebLocationMarketingId
                        //     });
                        //     if (franchiseLocation)
                        //     {
                        //         result.reviews = await this.embedClient.getBroadlyEmbedReviews({
                        //             broadlyLocationId: franchiseLocation.externalFranchiseReference,
                        //             page: params.page,
                        //             pageSize: params.pageSize
                        //         });
                        //     }
                        // }
                        // else
                        // {
                        _a = result;
                        return [4 /*yield*/, this.reviewClient.searchAggregateReviews({
                                PageNumber: params.page,
                                PageSize: params.pageSize,
                                ConceptId: params.conceptId,
                                FranchiseId: params.franchiseId,
                                FranchiseWebLocationId: params.franchiseWebLocationId,
                                FranchiseWebLocationMarketingId: params.franchiseWebLocationMarketingId
                            })];
                    case 1:
                        // if (params.dataSource == "embed" && (params.franchiseWebLocationId || params.franchiseWebLocationMarketingId))
                        // {
                        //     let franchiseLocation = await this.loadFranchise({
                        //         franchiseWebLocationId: params.franchiseWebLocationId,
                        //         franchiseWebLocationMarketingId: params.franchiseWebLocationMarketingId
                        //     });
                        //     if (franchiseLocation)
                        //     {
                        //         result.reviews = await this.embedClient.getBroadlyEmbedReviews({
                        //             broadlyLocationId: franchiseLocation.externalFranchiseReference,
                        //             page: params.page,
                        //             pageSize: params.pageSize
                        //         });
                        //     }
                        // }
                        // else
                        // {
                        _a.reviews = (_b.sent()).data;
                        // }
                        return [2 /*return*/, result];
                }
            });
        });
    };
    return CustomerReviewService;
}());
exports.CustomerReviewService = CustomerReviewService;
